var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade-left" } }, [
    _vm.item
      ? _c(
          "div",
          {
            staticClass: "sidecart__line-item",
            class: [
              _vm.itemClass,
              _vm.inKit ? "kit-" + _vm._kitId + "-" + (_vm.line - 1) : "",
              _vm.inKit ? "kit-item" : ""
            ]
          },
          [
            _c("div", {
              staticClass: "sidecart__line-item__image-wrapper",
              style: "backgroundImage: url(" + _vm.item.image + ")",
              attrs: { alt: _vm.item.product_title }
            }),
            _c("div", { staticClass: "sidecart__line-item__content" }, [
              _c(
                "p",
                {
                  staticClass: "body-sm strong-bold sidecart__line-item__title"
                },
                [_vm._v(_vm._s(_vm.itemName))]
              ),
              _c("p", { staticClass: "sidecart__line-item__price" }, [
                _vm.item.line_price > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "body-sm",
                        class:
                          ((_obj = {}),
                          (_obj[
                            "sidecart__line-item__price--discount " +
                              _vm.$store.state.comparePriceColor
                          ] = _vm.isDiscounted),
                          _obj)
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneyWithoutDecimals")(_vm.item.line_price)
                          )
                        )
                      ]
                    )
                  : _c("span", { staticClass: "body-sm" }, [_vm._v("FREE")]),
                _vm.isDiscounted
                  ? _c(
                      "s",
                      {
                        staticClass:
                          "body-sm sidecart__line-item__price--compare-at color-grey"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneyWithoutDecimals")(_vm.comparePrice)
                          )
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              !_vm.disableRemove
                ? _c(
                    "button",
                    {
                      staticClass:
                        "sidecart__line-item__remove color-black body-sm hover-opacity",
                      attrs: {
                        tag: "button",
                        label: "Remove",
                        "aria-label": "Remove item"
                      },
                      on: { click: _vm.removeItem }
                    },
                    [_vm._v("Remove")]
                  )
                : _vm._e()
            ]),
            !_vm.disableQuantity
              ? _c(
                  "div",
                  { staticClass: "sidecart__line-item__quantity" },
                  [
                    _c("quantity-selector", {
                      attrs: { value: _vm.item.quantity },
                      on: { input: _vm.updateQuantity }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }